import { IAnalogSetpoint } from './types'
import { useSetObjectValue } from '../../../hooks/useSetObjectValue';
import { Input } from "baseui/input";
import { useState } from 'react';
import { VscSettings } from 'react-icons/vsc';

const ValueInput = (props: IAnalogSetpoint) => {

  const [value, setValue, setValueResult, sendNow] = useSetObjectValue(props.id, props.resourceGroupId, "value", props.value,3000);
  const [internalValue, setInternalValue] = useState(props.value);
  const [error, setError] = useState(false);

  const onValueChanged = (e: any) => {
    const fValue = parseFloat(e.target.value);
    setInternalValue(fValue);
    const error = isBelowMin(fValue,props.limitMin) || isAboveMax(fValue,props.limitMax);
    setError(error);
    if ( !error)
      setValue(fValue);
  }

  const onBlur = () => {
    if ( !error)
      sendNow(internalValue);
  }

  return (
          <Input
            value={internalValue}
            startEnhancer={<VscSettings />}
            onChange={onValueChanged}
            disabled={setValueResult.isLoading}
            endEnhancer={props.dimension}
            error={setValueResult.isError || error}
            type='number'
            onBlur={onBlur}
          />
  )
}

export default ValueInput

const isBelowMin = (value: number, limitMin: number | undefined) => {
  if (limitMin === undefined)
    return false;
  if (limitMin === null)
    return false;

  return value < limitMin;
}

const isAboveMax = (value: number, limitMax: number | undefined) => {
  if (limitMax === undefined)
    return false;
  if (limitMax === null)
    return false;
  return value > limitMax;
}